import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Apollo } from "apollo-angular";
import { CookieService } from "ngx-cookie-service";
import { environment } from "src/environments/environment";
import { DELETE_CART_QUERY, FETCH_CART_QUERY, GET_CATEGORIES_QUERY, HomeCategoriesQuiery, SEARCHING_ITEMS_QUERY, SliderQuiery, SubCatQuiery, UPDATE_CART_QUERY } from "./app.queries";
import { HomeBrands } from "../HomeSerivice/QUERIES";
import { BaseService, LanguageService, WebsiteAttributesService } from "imakeapp-shared";









@Injectable({
  providedIn: 'root'
})
export class AppService extends BaseService
{


  constructor(
    private http: HttpClient,
    private apollo: Apollo,
    private webAttrService: WebsiteAttributesService,
    public override language_s: LanguageService
  ) {
    super(language_s);
  }


  get_categories()
  {



    return this.apollo.watchQuery({
      query: GET_CATEGORIES_QUERY(this.lang)
    }).valueChanges;

  }



  searching(search_string: string)
  {



    return this.apollo.watchQuery({
      query: SEARCHING_ITEMS_QUERY(this.lang),
      variables: {
        name: search_string
      },
      fetchPolicy: 'no-cache'
    }).valueChanges;
  }


  sign_in(data: any)
  {
    return this.http.post(`${environment.ApiEndPoint2}/login`, {
      username: data.username,
      password: data.password
    });
  }


  sign_up(data: any)
  {
    return this.http.post(`${environment.ApiEndPoint2}/createUser`, data);
  }




  request_add_to_cart(variables: any)
  {

    return this.http.post(`${environment.ApiEndPoint}/orders/addToCart`, variables);
  }

  add_to_cart(variables: any)
  {
    return this.http.post(`${environment.ApiEndPoint}/orders/addToCart`, variables);

  }

  get_cart(variables: any)
  {




    return this.apollo.watchQuery({
      query: FETCH_CART_QUERY(this.lang),
      variables: variables,
      fetchPolicy: 'no-cache'
    }).valueChanges;

  }

  delete_cart(variables: any)
  {
    return this.apollo.watchQuery({
      query: DELETE_CART_QUERY,
      variables: variables,
      fetchPolicy: 'no-cache'
    }).valueChanges;

  }







  get_areas()
  {
    return this.http.get(`${environment.ApiEndPoint2}/Cities/getCitiesForApp`);
  }




   get_site_theme()
  {
    return   this.webAttrService.get_site_attributes();
  }


  get_socials()
  {
    return this.http.get(`${environment.ApiEndPoint2}/socialUrls/index`);
  }



  GetSlider()
  {

    this.lang = this.language_s.get_site_active_lang_code();

    return this.apollo.watchQuery({
      query: SliderQuiery(this.lang),
   }).valueChanges;

  }

  GetSubcategory()
  {

    ;

    return this.apollo.watchQuery({
      query: SubCatQuiery(this.lang),
    }).valueChanges;

  }


  GetOffersData(){

    return  this.http.post(`${environment.ApiEndPoint}/MobileMainPage/GetHomePage`,{})

  }

  GetCategoriesData(){

    ;

    return this.apollo.watchQuery({
      query: HomeCategoriesQuiery(this.lang),
   }).valueChanges;

  }


GetHomeBrands(){



  return this.apollo.watchQuery({
    query: HomeBrands(this.lang),
 }).valueChanges;
}



}
